import {faBars} from '@fortawesome/free-solid-svg-icons/faBars';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {Link, withRouter} from 'react-router-dom';
import {configureAnchors, goToAnchor} from 'react-scrollable-anchor';
import {CSSTransition} from 'react-transition-group';
import styled from 'styled-components';
import logoCleanbill from '../assets/img/logo_cleanbill.png';
import SideMenu from './SideMenu';

export const TitleButton = styled(Link).attrs({
  className: 'menu-item',
})`
  &&& {
  background: linear-gradient(to left,rgb(90,18,111) 0%,rgb(201,0,95) 100%);
  border: 0;
  color: white;
  border-radius: 30px;
  height: 60%;
  padding: 0px 20px;
`;

export const NoPadCol = styled(Col)`
  padding: 0;
  display: flex;
  justify-content: flex-end;
`;

class Header extends PureComponent {

  state = {
    currentAnchor: this.props.currentAnchor,
    inProp: false,
  };

  componentDidMount() {
    configureAnchors({offset: -90});
  }

  anchorChange = anchor => {
    const {links, history} = this.props;
    this.setState({currentAnchor: anchor});
    links ? history.push('/#' + anchor) : goToAnchor(anchor);
  };

  setInProp = () => {
    this.setState({inProp: !this.state.inProp});
  };

  render() {
    const {currentAnchor, inProp} = this.state;
    const {history} = this.props;

    return (
      <Container className="header">
        <Row className="burger-menu">
          <Col xs={6} className="burger-btn-col">
            <button onClick={this.setInProp} className="burger-btn">
              <FontAwesomeIcon icon={faBars} color={'black'} size={'lg'} />
            </button>
            <CSSTransition in={inProp} timeout={200} classNames="sidebar">
              <div className="app-body">
                <SideMenu currentAnchor={currentAnchor} anchorChange={this.anchorChange} setInProp={this.setInProp} history={history}/>
              </div>
            </CSSTransition>
          </Col>
          <Col xs={6} className="burger-logo-col">
            <div>
              <img src={logoCleanbill} alt="cleanbill-logo" className="burger-cleanbill-logo" />
            </div>
          </Col>
        </Row>
        <Row className="full-header">
          <Col xs={12} className="full-header-list">
            <div>
              <img src={logoCleanbill} alt="cleanbill-logo" className="header-cleanbill-logo" />
            </div>
            <div className="items-list">
              <div className="rel-item">
                <button onClick={() => this.anchorChange('presentation')} className="menu-item">
                Cleanbill
                </button>
                {currentAnchor === 'presentation' && <div className="selected-item" />}
              </div>
              <div className="rel-item">
                <button onClick={() => this.anchorChange('advantages')} className="menu-item">
                Avantages
                </button>
                {currentAnchor === 'advantages' && <div className="selected-item" />}
              </div>
              <div className="rel-item">
                <button onClick={() => this.anchorChange('download')} className="menu-item">
                Téléchargement
                </button>
                {currentAnchor === 'download' && <div className="selected-item" />}
              </div>
              <div className="rel-item">
                <button onClick={() => this.anchorChange('newPartner')} className="menu-item">
                Pro
                </button>
                {currentAnchor === 'newPartner' && <div className="selected-item" />}
              </div>
              <div className="rel-item">
                <button onClick={() => this.anchorChange('contact')} className="menu-item">
                Contact
                </button>
                {currentAnchor === 'contact' && <div className="selected-item" />}
              </div>
              <TitleButton className="menu-item" to="/login">
                Mon compte
              </TitleButton>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

Header.defaultProps = {
  currentAnchor: 'presentation',
};

Header.propTypes = {
  currentAnchor: PropTypes.string.isRequired,
  history: PropTypes.any.isRequired,
};

export default withRouter(Header);
